import React from 'react';

const Batch = ({ data }) => {
    if (!data) return null;

    const { request_id, job_ids, total_files, status, message } = data;

    return (
        <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-8">
                <div className="card border-success shadow-sm mb-4">
                    <div className="card-body">
                        <div className="text-center">
                            <i className="fas fa-check-circle text-success mb-3" style={{ fontSize: '3rem' }}></i>
                            <h4 className="text-success mb-3">Data Extraction Started!</h4>
                            
                            <div className="alert alert-info mb-4" role="alert">
                                <strong>Request ID:</strong> <code>{request_id}</code>
                            </div>

                            <div className="row text-center mb-4">
                                <div className="col-md-4">
                                    <div className="bg-light p-3 rounded">
                                        <h5 className="mb-1">{total_files || 0}</h5>
                                        <small className="text-muted">Files Uploaded</small>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="bg-light p-3 rounded">
                                        <h5 className="mb-1">{job_ids?.length || 0}</h5>
                                        <small className="text-muted">Jobs Created</small>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="bg-light p-3 rounded">
                                        <h5 className="mb-1 text-secondary">
                                            <i className="fas fa-spinner fa-spin me-1"></i>
                                            {status || 'Processing'}
                                        </h5>
                                        <small className="text-muted">Current Status</small>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-4">
                                <p className="text-muted mb-2">{message}</p>
                                <p className="small text-muted">
                                    You can check the results later in the <strong>View Extractions</strong> section using the Request ID above.
                                </p>
                            </div>

                            <div className="border-top pt-4">
                                <h6 className="mb-3 text-muted">What happens next?</h6>
                                <div className="row text-start">
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-clock text-primary me-2"></i>
                                            <span className="small">Processing typically takes 3-5 minutes per file</span>
                                        </div>
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-bell text-info me-2"></i>
                                            <span className="small">You will receive an email notification incase of any failure</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-history text-secondary me-2"></i>
                                            <span className="small">Check progress in the <strong>View Extractions</strong> section</span>
                                        </div>
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-download text-success me-2"></i>
                                            <span className="small">Download results once the processing is completed</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Batch;